import { SearchOutlined } from '@ant-design/icons'
import { useAmp } from 'next/amp'
import Image from 'next/image'
import { FC } from 'react'
import { isMobile } from 'react-device-detect'
import { Form, Input, Select } from 'src/@legacy/@core/components/share/ANTD'
import { useTranslation } from 'src/@legacy/@core/hooks/UserTranslation'
import { TraslateFuncType } from 'src/@legacy/hooks/Common'
import { nonAccentVietnamese } from 'src/@legacy/utilities/common'
import BookIcon from '../../hr-glossary/assets/application_read.svg'

export type JDCateType = {
  articles: number[]
  categories_name: string
  categories_name_vi: string
  date_created: string
  date_updated: string
  description: string
  description_vi: string
  icon: string
  id: number
  index: number
  is_parent: boolean
  job_description_content: any
  slug: string
  sort: string
  status: string
  user_updated: string
}
export type JDSearchType = {
  search?: string | string[]
  category?: number | string | string[]
}
const JDSearch: FC<{
  initialValues: JDSearchType
  onSubmit: (value: JDSearchType) => void
  JDCateList: JDCateType[]
  translate: TraslateFuncType
  currentLanguage: string
}> = ({ initialValues, onSubmit, JDCateList, translate, currentLanguage }) => {
  const isAMP = useAmp()
  return currentLanguage ? (
    <Form initialValues={initialValues} onFinish={onSubmit}>
      <style jsx global>{`
        .glossary-search {
          position: relative;
          z-index: 1;
          margin-top: -40px;
          background-color: #fff;
          border-radius: 8px;
          box-shadow: 0 4px 8px 0 rgba(168, 178, 186, 0.3);
          padding: 16px;

          margin-bottom: 40px;
        }
        .glossary-search__wrapper {
          display: flex;
          justify-content: space-between;
        }
        .glossary-search__input {
          width: calc(77% - 8px);
        }
        .glossary-search__input .ant-input-affix-wrapper {
          height: 48px;
        }
        .glossary-search__input .ant-input-prefix {
          margin-right: 8px;
        }
        .glossary-search__input input::placeholder,
        .glossary-search__title .ant-select-selection-placeholder {
          color: #7a7c82;
        }
        .glossary-search__title {
          width: calc(23% - 8px);
          position: relative;
        }
        .glossary-search__title .ant-select {
          width: 100%;
        }
        .glossary-search__title .ant-select-single:not(.ant-select-customize-input) .ant-select-selector,
        .glossary-search__title
          .ant-select-single:not(.ant-select-customize-input)
          .ant-select-selector
          .ant-select-selection-search-input {
          height: 48px;
          padding-left: 24px;
        }
        .glossary-search__title .ant-select-single.ant-select-show-arrow .ant-select-selection-item {
          line-height: 48px;
        }
        .glossary-search__title .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
          padding-left: 34px;
        }
        .glossary-search__title .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
          line-height: 48px;
        }
        .glossary-search__title-icon {
          position: absolute;
          z-index: 1;
          top: calc(50% - 8px);
          left: 10px;
        }

        @media only screen and (max-width: 576px) {
          .glossary-search__wrapper {
            display: block;
          }
          .glossary-search {
            margin-top: -67px;
            margin-bottom: 24px;
          }
          .glossary-search__input {
            width: 100%;
            margin-bottom: 8px;
          }
          .glossary-search__title {
            width: 100%;
          }
        }
      `}</style>
      <div className="glossary-search">
        <div className="glossary-search__wrapper">
          <div className="glossary-search__input">
            <Form.Item name="search" className="mb-0">
              <Input
                allowClear
                placeholder={translate('resources:search_by_job_title')}
                {...(isMobile && {
                  enterkeyhint: 'search',
                  onKeyPress: (e) => {
                    if (e.keyCode === 0) {
                      e.currentTarget.blur()
                      onSubmit({ category: initialValues.category, search: e.currentTarget.value })
                    }
                  }
                })}
                onKeyUp={(e) => {
                  if (e.keyCode === 13) onSubmit({ category: initialValues.category, search: e.currentTarget.value })
                }}
                prefix={<SearchOutlined style={{ fontSize: 16, color: '#6c7b8d' }} />}
                onChange={(e) => {
                  if (!e.currentTarget.value) onSubmit({ category: initialValues.category, search: '' })
                }}
              />
            </Form.Item>
          </div>
          <div className="glossary-search__title">
            <span className="glossary-search__title-icon">
              {!isAMP ? <Image src={BookIcon} /> : <img width={16} height={16} src={BookIcon.src} />}
            </span>
            <Form.Item name="category" className="mb-0">
              <Select
                allowClear
                showSearch
                onChange={(value) => {
                  onSubmit({ search: initialValues?.search, category: value ? String(value) : '' })
                }}
                options={(JDCateList || []).map((jdCate) => ({
                  label: currentLanguage === 'en' ? jdCate.categories_name : jdCate.categories_name_vi,
                  value: String(jdCate.id),
                  category_name_vi: jdCate.categories_name_vi,
                  category_name: jdCate.categories_name,
                  category_name_vi_non_accent: nonAccentVietnamese(jdCate.categories_name_vi || '')
                }))}
                filterOption={(input, option) => {
                  return (
                    option?.category_name_vi?.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option?.category_name?.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option?.category_name_vi_non_accent?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  )
                }}
                placeholder={translate('resources:job_function')}
              />
            </Form.Item>
          </div>
        </div>
      </div>
    </Form>
  ) : null
}

export default JDSearch
